module.exports = __webpack_public_path__ + "static/media/onboard-7-sharing.dbc1d99b.gif";